import { twJoin } from 'tailwind-merge';

import { HStack } from '@/components/ui/hstack';
import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';
import { parseSurveyHtml, type SurveyTextRun } from '../../model/surveyHtml';

interface SurveyHtmlBlockProps {
  html: string;
}

function TextRuns({ runs }: { runs: SurveyTextRun[] }) {
  return (
    <Text className="text-typography-700">
      {runs.map((run, index) => (
        <Text
          key={index}
          className={twJoin(
            'text-typography-700',
            run.bold && 'font-bold',
            run.italic && 'italic'
          )}>
          {run.text}
        </Text>
      ))}
    </Text>
  );
}

/** Renders a survey `html` display element via `parseSurveyHtml`'s paragraph/bullet-list blocks. */
export function SurveyHtmlBlock({ html }: SurveyHtmlBlockProps) {
  const blocks = parseSurveyHtml(html);

  return (
    <VStack space="xs">
      {blocks.map((block, index) =>
        block.type === 'bullet-list' ? (
          <VStack key={index} space="xs" className="pl-1">
            {block.items.map((item, itemIndex) => (
              <HStack key={itemIndex} space="sm" className="items-start">
                <Text className="text-typography-700" aria-hidden accessibilityElementsHidden>
                  •
                </Text>
                <TextRuns runs={item} />
              </HStack>
            ))}
          </VStack>
        ) : (
          <TextRuns key={index} runs={block.runs} />
        )
      )}
    </VStack>
  );
}
